import { ALWAYS_PREMIUM } from "../config/featureFlags";

export async function createPremiumCheckoutSession({ user, metadata = {}, priceId } = {}) {
    if (!user?.uid) {
        throw new Error("Utilisateur non connecté. Veuillez vous identifier pour continuer.");
    }

    // Short-circuit billing when ALWAYS_PREMIUM is enabled
    if (ALWAYS_PREMIUM) {
        // Return a local dashboard URL so callers can redirect without errors
        const origin = typeof window !== 'undefined' ? window.location.origin : '';
        return `${origin}/dashboard`;
    }

    const subscriptionProductId = process.env.REACT_APP_STRIPE_PRODUCT_ID;
    const subscriptionAmount = Number(process.env.REACT_APP_STRIPE_AMOUNT_CENTS ?? "0");
    const subscriptionCurrency = process.env.REACT_APP_STRIPE_CURRENCY || "eur";

    if (!priceId && (!subscriptionProductId || subscriptionAmount <= 0)) {
        throw new Error("Configuration Stripe manquante. Définissez REACT_APP_STRIPE_PRODUCT_ID et REACT_APP_STRIPE_AMOUNT_CENTS.");
    }

    const payload = {
        productId: subscriptionProductId,
        amountCents: subscriptionAmount,
        currency: subscriptionCurrency,
        clientReferenceId: user.uid,
        customerEmail: user.email,
        metadata: {
            plan: "premium",
            ...metadata,
        },
    };

    if (typeof window !== "undefined") {
        payload.origin = window.location.origin;
    }

    if (priceId) {
        payload.priceId = priceId;
    }

    const response = await fetch("/api/create-checkout-session", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    let data = null;
    try {
        data = await response.json();
    } catch (error) {
        // ignore parse error, we'll handle below
    }

    if (!response.ok) {
        const message = data?.error || "Impossible de créer la session de paiement Stripe.";
        throw new Error(message);
    }

    if (!data?.url) {
        throw new Error("Session Stripe invalide : URL manquante.");
    }

    return data.url;
}
